import {react2angular} from 'react2angular';
import common from 'infra/utils/common';
import {validateUserAuthentication} from '../../data/audience-linkedin-helper';
import LifestyleModal from 'react/components/apps/audience/AudienceBuilder/Modals/LifestyleModal/LifestyleModal';

import CommercialsModal from 'react/components/apps/audience/AudienceBuilder/Modals/CommercialsModal/CommercialsModal';
import TvShowsModal from 'react/components/apps/audience/AudienceBuilder/Modals/TvShowsModal/TvShowsModal';
import AdvancedTvShowsModal from 'react/components/apps/audience/AudienceBuilder/Modals/AdvancedTvShowsModal/AdvancedTvShowsModal';
import LinkedinDemographicsModal
    from 'react/components/apps/audience/AudienceBuilder/Modals/LinkedinDemographicsModal/LinkedinDemographicsModal';
import LinkedinIndustriesModal from 'react/components/apps/audience/AudienceBuilder/Modals/LinkedinIndustriesModal/LinkedinIndustriesModal';
import DemographicsModal from 'react/components/apps/audience/AudienceBuilder/Modals/DemographicsModal/DemographicsModal';
import FirstPartyModal from 'react/components/apps/audience/AudienceBuilder/Modals/FirstPartyModal/FirstPartyModal';
import LoadAudienceModal from 'react/components/apps/audience/AudienceBuilder/Modals/LoadAudienceModal/LoadAudienceModal';
import NewAudiencesModal from 'react/components/apps/audience/AudienceBuilder/Modals/NewAudiencesModal/NewAudiencesModal';
import {checkNameSensitivity, checkSensitivity} from 'react/utils/sensitivityUtils';
import ReviewSensitivityModal
    from 'react/components/apps/audience/AudienceBuilder/Modals/ReviewSensitivityModal/ReviewSensitivityModal';
import AudienceNameModal
    from 'react/components/apps/audience/AudienceBuilder/Modals/AudienceNameModal/AudienceNameModal';
import AudiencePreviewWidget
    from 'react/components/apps/audience/AudienceBuilder/AudiencePreviewWidget/AudiencePreviewWidget';
import UnifiedTvAudiencePreviewWidget
    from 'react/components/apps/audience/AudienceBuilder/UnifiedTvAudiencePreviewWidget/UnifiedTvAudiencePreviewWidget';
import SegmentsImageToggleButtonSelector
    from 'react/components/apps/audience/AudienceBuilder/SegmentsImageToggleButtonSelector/SegmentsImageToggleButtonSelector.js';
import AudienceTarget from 'react/components/apps/audience/AudienceBuilder/AudienceTarget/AudienceTarget';
import AudienceSecondaryBar
    from 'react/components/apps/audience/AudienceBuilder/AudienceSecondaryBar/AudienceSecondaryBar';
import CloneAudience from 'react/components/apps/audience/AudienceBuilder/CloneAudience/CloneAudience';
import add_tooltip from 'common/tooltip/tooltip.js';
import {
    getSegmentValuesSummary,
    hasActivateAudiencePermission,
    isActivateAudienceEnabled,
    SEGMENT_ROW_MAP,
    LOGICAL_OPERANDS,
    TV_SHOWS_SEGMENT_TYPES,
    COMMERCIALS_SEGMENT_TYPES,
    DEMOGRAPHICS_SEGMENT_TYPES,
    isDeterministicDynamicActivationAllowed,
    isSmartTvChannel,
    isAdvancedTvChannel,
    deterministicPermissionName,
    customPricePermissionName,
    optimizeSegmentPermissionName,
    CHANNELS,
    DEFAULT_MANDATORY_GEO,
    showAudienceIpCountPermissionName,
    SEGMENT_ROW_TYPES,
    getCountryGeoFromSegment,
    UNIFIED_TV_SOURCES,
    getUnifiedTvActivatableSources,
} from '../../data/audience-segment-builder-helper';
import {
    createAlwaysOnAudience,
    createAmplifiedAudience,
    createAudienceTargetTaxonomy,
    createAudienceTargetUserList,
    createDeterministicAudience,
    createUserListForDeterministicAudience,
    getAdvancedTvGenresMetaData,
    getAmplifiedEstimatedReachGoal,
    getAudienceSize,
    getAmpModelCategory,
    getDataContract,
    getFirstPartyDataByProgram,
    getLinkedinMetaData,
    getSegmentIds,
    getSegmentInsightsData,
    getSegmentInsightsParams,
    getTaxonomyCategory,
    getTvCommercialsMetaDataV2,
    getTvGenresMetaData,
    getTvNetworksMetaData,
    getTvShowsMetaData,
    isAudienceSizeTooSmall,
} from '../../react/services/AudienceInsightsService';
import {QUERY_NAMES} from '../../react/services/AudienceServiceHelper';
import * as MixpanelAudience from '../../react/infra/mixpanel/MixpanelAudience';
import {PERMISSION} from "../../infra/utils/export";

const audienceBuilderModule = angular.module(__filename, [
    require("./modals/interests-modal").name,
    require("./modals/websites-modal").name,
    require("./modals/linkedin/linkedin-companies-modal").name,
    require("./modals/linkedin/linkedin-jobs-modal").name,
    require("../../widgets/audience-preview-widget/audience-preview-widget").name,
    require('../../widgets/unified-tv-audience-preview-widget/unified-tv-audience-preview-widget').name,
    require('common/modals/confirmation/confirm-action.modal.service').name,
    require("data/audience-mgmt").name,
    require("./modals/apps-modal").name
]);

audienceBuilderModule
    .component('reactAudiencePreviewWidget', react2angular(AudiencePreviewWidget, [
        'activatedAdvertiser',
        'activatedAmplifiedThreshold',
        'activatedAlwaysOnThreshold',
        'activateAudienceDisabledText',
        'activatedMarket',
        'activatedDataContractId',
        'activatedDataContractText',
        'activatedCategoryId',
        'audienceDistributionService',
        'audienceId',
        'audienceName',
        'audienceSegment',
        'channel',
        'createAmplifiedAudience',
        'createAlwaysOnAudience',
        'createAudienceTargetTaxonomy',
        'createAudienceTargetUserList',
        'createDeterministicAudience',
        'createUserListForDeterministicAudience',
        'createUnifiedTvActivation',
        'dspService',
        'getAmplifiedEstimatedReachGoal',
        'getAmpModelCategory',
        'getDataContract',
        'getSegmentIds',
        'getTaxonomyCategory',
        'handleActivatingAudience',
        'handleActivatingTarget',
        'hasAmplificationModeSelector',
        'householdDistributionService',
        'isActivateAudienceEnabled',
        'isActivateAudienceVisible',
        'isActivateEnabled',
        'isActivateTargetEnabled',
        'isActivateVisible',
        'isAudienceAmplifiedActivated',
        'isAudienceAlwaysOnActivated',
        'isAudienceDeterministicActivated',
        'isDeterministicDynamicAllowed',
        'isRequestCancelledService',
        'isTargetModalProcessing',
        'isContextualUniquenessError',
        'marketsAndAdvertisersPromise',
        'notificator',
        'onAudienceDataLoaded',
        'onExploreAudience',
        'onTargetAudienceSubmit',
        'ssoService',
        'trackTooNarrow',
        'updateAudienceAmplifiedActivated',
        'updateAudienceAlwaysOnActivated',
        'updateAudienceDeterministicActivated',
        'userId',
        'allowDeterministicSegment',
        'allowCustomPriceSegment',
        'allowOptimizeSegment',
        'hideAudiencePreview',
        'showAudienceIpCount',
        'hideExploreButton',
        'sourceLabel',
        'sourceColorClass',
    ]))
    .component('reactUnifiedTvAudiencePreviewWidget', react2angular(UnifiedTvAudiencePreviewWidget, [
        'sources',
        'activatedAdvertiser',
        'activatedAmplifiedThreshold',
        'activatedAlwaysOnThreshold',
        'activateAudienceDisabledText',
        'activatedMarket',
        'activatedDataContractId',
        'activatedDataContractText',
        'activatedCategoryId',
        'audienceDistributionService',
        'audienceId',
        'audienceName',
        'audienceSegment',
        'channel',
        'createAmplifiedAudience',
        'createAlwaysOnAudience',
        'createAudienceTargetTaxonomy',
        'createAudienceTargetUserList',
        'createDeterministicAudience',
        'createUserListForDeterministicAudience',
        'createUnifiedTvActivation',
        'dspService',
        'getAmplifiedEstimatedReachGoal',
        'getAmpModelCategory',
        'getDataContract',
        'getSegmentIds',
        'getTaxonomyCategory',
        'handleActivatingAudience',
        'onUnifiedAudiencesActivated',
        'handleActivatingTarget',
        'hasAmplificationModeSelector',
        'householdDistributionService',
        'isActivateAudienceEnabled',
        'isActivateAudienceVisible',
        'isActivateEnabled',
        'isActivateTargetEnabled',
        'isActivateVisible',
        'isAudienceAmplifiedActivated',
        'isAudienceAlwaysOnActivated',
        'isAudienceDeterministicActivated',
        'isDeterministicDynamicAllowed',
        'isRequestCancelledService',
        'isContextualUniquenessError',
        'marketsAndAdvertisersPromise',
        'notificator',
        'onAudienceDataLoaded',
        'onExploreAudience',
        'ssoService',
        'trackTooNarrow',
        'updateAudienceAmplifiedActivated',
        'updateAudienceAlwaysOnActivated',
        'updateAudienceDeterministicActivated',
        'userId',
        'allowDeterministicSegment',
        'allowCustomPriceSegment',
        'allowOptimizeSegment',
        'hideAudiencePreview',
        'showAudienceIpCount',
    ]))
    .component('lifestyleModal', react2angular(LifestyleModal, ['isOpen', 'modalTitle', 'onSubmit', 'onCancel', 'lifestyleInput', 'lifestyles']))
    .component('firstPartyModal', react2angular(FirstPartyModal, ['isOpen', 'modalTitle', 'onSubmit', 'onCancel', 'firstPartySegments', 'firstPartyInput', 'isLoading']))
    .component('loadAudienceModal', react2angular(LoadAudienceModal, ['isOpen', 'modalTitle', 'data', 'onSubmit', 'onCancel', 'onDelete', 'channel', 'isActivateAudienceVisible', 'userPermissions']))
    .component('reactNewAudiencesModal', react2angular(NewAudiencesModal, ['isOpen', 'audiences', 'onClose']))
    .component('segmentsImageToggleButtonSelector', react2angular(SegmentsImageToggleButtonSelector, ['segmentsData', 'selectedSegment', 'onToggle']))
    .component('commercialsModal', react2angular(CommercialsModal, ['isOpen', 'modalTitle', 'onSubmit', 'onCancel', 'commercialsInput', 'commercialsMetadataPromise', 'channel', 'isTimeframeVisible', 'geo']))
    .component('tvShowsModal', react2angular(TvShowsModal, ['isOpen', 'modalTitle', 'onSubmit', 'onCancel', 'tvShowsInput', 'channel', 'tvNetworksMetadataPromise', 'tvGenresMetadataPromise', 'tvShowsMetadataPromise', 'channel', 'isTimeframeVisible']))
    .component('advancedTvShowsModal', react2angular(AdvancedTvShowsModal, ['isOpen', 'modalTitle', 'onSubmit', 'onCancel', 'tvShowsInput', 'tvGenresMetadataPromise', 'channel', 'geo']))
    .component('demographicsModal', react2angular(DemographicsModal, ['isOpen', 'modalTitle', 'onSubmit', 'onCancel', 'demographicsInput', 'allGeos', 'disableGeos', 'defaultGeo', 'isGeoOnly', 'channel', 'hasUsGeoPermission', 'hasSgTelcoEthnicityPermission', 'type']))
    .component('linkedinDemographicsModal', react2angular(LinkedinDemographicsModal, ['isOpen', 'modalTitle', 'onSubmit', 'onCancel', 'demographicsInput', 'disableGeos', 'linkedinMetaDataPromise']))
    .component('linkedinIndustriesModal', react2angular(LinkedinIndustriesModal, ['isOpen', 'modalTitle', 'onSubmit', 'onCancel', 'industriesInput', 'linkedinMetaDataPromise']))
    .component('reviewSensitivityModal', react2angular(ReviewSensitivityModal, ['isOpen', 'data', 'modalTitle', 'keepPhrasesText', 'removePhrasesText', 'onSubmit', 'onCancel', 'segmentMap']))
    .component('audienceNameModal', react2angular(AudienceNameModal, ['isOpen', 'origName', 'origErrorMessage', 'checkName', 'onSubmit', 'onCancel']))
    .component('audienceTarget', react2angular(AudienceTarget, ['marketsAndAdvertisersPromise', 'audienceId', 'audienceName',
        'audienceSegment', 'isActivateEnabled', 'isActivateAudienceEnabled', 'isActivateAudienceVisible', 'activateAudienceDisabledText',
        'isActivateTargetEnabled', 'isActivateVisible', 'channel', 'getSegmentIds', 'createAudienceTargetTaxonomy',
        'createAudienceTargetUserList', 'createAmplifiedAudience', 'createAlwaysOnAudience', 'notificator',
        'updateAudienceDeterministicActivated', 'dspService', 'isAudienceDeterministicActivated', 'activatedAmplifiedThreshold',
        'activatedAlwaysOnThreshold', 'isAudienceAmplifiedActivated', 'isAudienceAlwaysOnActivated', 'activatedMarket',
        'activatedAdvertiser', 'activatedDataContractId', 'activatedDataContractText', 'activatedCategoryId',
        'updateAudienceAmplifiedActivated', 'updateAudienceAlwaysOnActivated', 'ssoService', 'getAmplifiedEstimatedReachGoal',
        'createDeterministicAudience', 'createUserListForDeterministicAudience', 'handleActivatingAudience', 'handleActivatingTarget',
        'widgetName', 'hasAmplificationModeSelector', 'getDataContract', 'getTaxonomyCategory', 'getAmpModelCategory', 'isDeterministicDynamicAllowed',
        'allowDeterministicSegment', 'allowCustomPriceSegment', 'allowOptimizeSegment']))
    .component('audienceSecondaryBar', react2angular(AudienceSecondaryBar, ['hasNoSegments', 'disableLoadAudience', 'onNewAudienceClick', 'onLoadAudienceClick',
        'onSaveAudienceClick', 'isDropdownVisible', 'audienceChannels', 'selectedChannel', 'onChannelChange', 'isAudienceActivated', 'createClonedAudience',
        'isCloneAudienceVisible']))
    .component('cloneAudience', react2angular(CloneAudience, ['createClonedAudience', 'updateIsCloneAudienceOpen', 'isOpen', 'audienceId', 'audienceName', 'audienceSegment']));

audienceBuilderModule.stateConfig = [{
    name: "audience-builder",
    url: "/audience-builder",
    params: {tokenStatus: null, channel: null},
    template: require("./audience-builder.html"),
    display: "Audience",
    data: {
        permissions: ['audience']
    },
    context: {
        audience_segment: "GeneralMold"
    },
    controller: audienceBuilderController
}];

audienceBuilderController.$inject = ['$scope', 'context', 'audienceMgmt', 'filtersPartition', 'interestsModal',
    'websitesModal', 'notificator', 'confirmAction', 'linkedinJobsModal', 'linkedinCompaniesModal',
    'abiPermissions', '$stateParams', '$state', 'errorMgmt', '$window', '$rootScope', 'appsModal', 'dspService',
    'ssoService', '$location', 'audienceTableStructure', 'TargetsCommon', '$timeout'];

    const disabledSegment = (segment) => ({...segment, isDisabled: true, tagLabel: 'Coming soon'});
    const debugOnlySegment = (segment) => ({...segment, debugOnly: true});
const WEB_SEGMENT_TYPES = [
    SEGMENT_ROW_TYPES.DEMOGRAPHICS,
    SEGMENT_ROW_TYPES.INTERESTS,
    SEGMENT_ROW_TYPES.WEBSITES,
    SEGMENT_ROW_TYPES.LIFESTYLE,
    SEGMENT_ROW_TYPES.FIRST_PARTY
];

const SG_TELCO_SEGMENT_TYPES = [
    SEGMENT_ROW_TYPES.DEMOGRAPHICS,
    SEGMENT_ROW_TYPES.INTERESTS,
    SEGMENT_ROW_TYPES.WEBSITES
];

const SMART_TV_SEGMENT_TYPES = [
    SEGMENT_ROW_TYPES.SMART_TV_DEMOGRAPHICS,
    SEGMENT_ROW_TYPES.INTERESTS,
    SEGMENT_ROW_TYPES.WEBSITES,
    SEGMENT_ROW_TYPES.LIFESTYLE,
    SEGMENT_ROW_TYPES.TV_SHOWS,
    SEGMENT_ROW_TYPES.SMART_TV_COMMERCIALS,
    SEGMENT_ROW_TYPES.FIRST_PARTY
];

const ADVANCED_TV_SEGMENT_TYPES = [
    SEGMENT_ROW_TYPES.SMART_TV_DEMOGRAPHICS,
    SEGMENT_ROW_TYPES.INTERESTS,
    SEGMENT_ROW_TYPES.WEBSITES,
    SEGMENT_ROW_TYPES.LIFESTYLE,
    SEGMENT_ROW_TYPES.ADVANCED_TV_SHOWS,
    SEGMENT_ROW_TYPES.SMART_TV_COMMERCIALS,
    SEGMENT_ROW_TYPES.FIRST_PARTY
];

const STREAMING_SEGMENT_TYPES = [
    SEGMENT_ROW_TYPES.SMART_TV_DEMOGRAPHICS,
    SEGMENT_ROW_TYPES.INTERESTS,
    SEGMENT_ROW_TYPES.WEBSITES,
    SEGMENT_ROW_TYPES.LIFESTYLE,
    SEGMENT_ROW_TYPES.ADVANCED_TV_SHOWS,
    SEGMENT_ROW_TYPES.FIRST_PARTY
];

const AU_TELCO_SEGMENT_TYPES = [
    SEGMENT_ROW_TYPES.DEMOGRAPHICS,
    SEGMENT_ROW_TYPES.INTERESTS,
    SEGMENT_ROW_TYPES.WEBSITES,
    debugOnlySegment(SEGMENT_ROW_TYPES.LIFESTYLE),
    debugOnlySegment(disabledSegment(SEGMENT_ROW_TYPES.APPS))
];

const LINKEDIN_SEGMENT_TYPES = [
    SEGMENT_ROW_TYPES.LINKEDIN_DEMOGRAPHICS,
    SEGMENT_ROW_TYPES.LINKEDIN_INDUSTRIES,
    SEGMENT_ROW_TYPES.LINKEDIN_COMPANIES,
    SEGMENT_ROW_TYPES.LINKEDIN_JOBS
];

const channelToSegmentTypes = {
    linkedin: LINKEDIN_SEGMENT_TYPES,
    unified_tv: STREAMING_SEGMENT_TYPES,
    data_spark: SG_TELCO_SEGMENT_TYPES,
    snbb: SG_TELCO_SEGMENT_TYPES,
    sg_bidstream: SG_TELCO_SEGMENT_TYPES,
    bidstream: WEB_SEGMENT_TYPES,
    au_telco: AU_TELCO_SEGMENT_TYPES,
    articles: WEB_SEGMENT_TYPES,
    smart_tv_inscape: SMART_TV_SEGMENT_TYPES,
    tivo: ADVANCED_TV_SEGMENT_TYPES,
    hisense: ADVANCED_TV_SEGMENT_TYPES,
    peerlogix: STREAMING_SEGMENT_TYPES,
};

function audienceBuilderController($scope, context, audienceMgmt, filtersPartition, interestsModal, websitesModal,
    notificator, confirmAction, linkedinJobsModal, linkedinCompaniesModal, abiPermissions,
    $stateParams, $state, errorMgmt, $window, $rootScope, appsModal, dspService, ssoService, $location,
    audienceTableStructure, TargetsCommon, $timeout) {

    let current_channel;
    let linkedinMetaDataPromise;
    let originalAudienceName = '';
    const ALL_DEMOGRAPHICS_SEGMENT_TYPES = [...DEMOGRAPHICS_SEGMENT_TYPES, 'linkedinDemographics'];
    const debugUser = $scope.$root.user.userType === 'debug';
    const userId = $scope.$root.user.id;
    const SEGMENT_MODAL_MAP = {
        interests: interestsModal, websites: websitesModal, linkedinJobs: linkedinJobsModal,
        linkedinCompanies: linkedinCompaniesModal, apps: appsModal
    };
    const CHANNEL_TO_LIFESTYLE_NAME_MAP = {
        articles: 'articlesBehavioralSegment',
        bidstream: 'articlesBehavioralSegment',
        au_telco: 'auTelcoBehavioralSegment',
        data_spark: 'sgTelcoBehavioralSegment',
        smart_tv: 'inscapeBehavioralSegment'
    };
    const ALL_GEOS = {label: 'All Geos', value: 'all', id: -1};
    $scope.SEGMENT_ROW_MAP = SEGMENT_ROW_MAP;
    $scope.logicalOperands = LOGICAL_OPERANDS;
    validateChannelContext();
    validateFirstPartySegmentContext();
    loadFromContext();
    changeSegmentTypes(current_channel);
    disableEnableLinkedinSegments();

    MixpanelAudience.trackPageView('audience-builder', context.current.audience_app.current_channel.value);

    $scope.getSegmentIds = getSegmentIds;
    $scope.createAudienceTargetTaxonomy = createAudienceTargetTaxonomy;
    $scope.createAudienceTargetUserList = createAudienceTargetUserList;
    $scope.createAmplifiedAudience = createAmplifiedAudience;
    $scope.createAlwaysOnAudience = createAlwaysOnAudience;
    $scope.createDeterministicAudience = createDeterministicAudience;
    $scope.createUserListForDeterministicAudience = createUserListForDeterministicAudience;
    // PHOB-1857: unified TV activation goes through abi-mgmt (per-source split + dispatch), not the
    // per-channel React activation services. audienceMgmt fills p_id and carries auth.
    $scope.createUnifiedTvActivation = (segmentId, body, ssoAccessToken) =>
        audienceMgmt.activateUnified(segmentId, body, ssoAccessToken);
    $scope.getAmpModelCategory = getAmpModelCategory;
    $scope.getDataContract = getDataContract;
    $scope.getTaxonomyCategory = getTaxonomyCategory;
    $scope.dspService = dspService;
    $scope.ssoService = ssoService;
    $scope.notificator = notificator;
    $scope.filtersPartition = filtersPartition;
    $scope.context = context;
    $scope.channelFilterSideMenuSelectedChannel = $scope.audienceChannelsFilter.find((channel) => channel.value === context.current.audience_app.current_channel.value);
    $scope.audience = $scope.audience || {};
    $scope.isCloneAudienceOpen = false;
    $scope.isTimeframeVisible = abiPermissions.hasPermission(PERMISSION.TVA_CUSTOM_TIMEFRAME);

    /**
     * Fetches fresh first party data from API for filtering
     * @returns {Promise<Array>} Fresh first party data (including expired segments)
     */
    async function getFirstPartyDataForFiltering() {
        // Only fetch if user has first party permission
        if (!abiPermissions.hasPermission(PERMISSION.FIRST_PARTY_SEGMENT)) {
            return [];
        }

        try {
            const data = await getFirstPartyDataByProgram(
                context.program,
                { shouldFetchSegmentSizes: true }
            );
            return data || [];
        } catch (error) {
            console.error('Error fetching first party data for filtering:', error);
            return [];
        }
    }

    /**
     * Filters out expired first party segments from audiences list using fresh API data
     * @param {Array} audiences - Array of audience objects
     * @param {Array} firstPartyData - Fresh first party data from API (source of truth)
     * @returns {Array} Filtered audiences with expired first party segments removed
     */
    function filterExpiredFirstPartySegments(audiences, firstPartyData = []) {
        return audiences.filter((audience) => {
            if (!audience.segments || !Array.isArray(audience.segments)) {
                return true;
            }

            // Filter out expired first party segments using fresh API data as source of truth
            const allSegmentsAreActive = audience.segments.every((segment) => {
                if (segment.type !== '1st party') {
                    return true; // Keep all non-first-party segments
                }

                // Try to match segment with fresh data by different possible fields
                let firstPartySegment = firstPartyData.find((item) => item.id === segment.id);
                if (!firstPartySegment && segment.segment_value) {
                    firstPartySegment = firstPartyData.find((item) => item.segment_value === segment.segment_value);
                }
                if (!firstPartySegment && segment.value) {
                    firstPartySegment = firstPartyData.find((item) => item.segment_value === segment.value);
                }

                // If segment not found in fresh data, it was deleted - exclude it
                if (!firstPartySegment) {
                    return false;
                }

                // If segment has pending_expiration flag set to true - exclude it
                if (firstPartySegment.pending_expiration === true) {
                    return false;
                }

                return true; // Keep active first party segments
            });

            return allSegmentsAreActive;
        });
    }

    // Define deleteAudienceHandler before modal configuration
    $scope.deleteAudienceHandler = async (audience) => {
        const confirmationMsg = `Are you sure you want to delete the audience ${audience.name}?
                               It will affect all users who share the program.`;
        const modal = await confirmAction.getConfirmation(confirmationMsg, 'Delete', 'Cancel', 'Delete audience', 'audience-confirmation', true);
        const confirmation = await modal.close;
        if (confirmation) {
            await audienceMgmt.delete(audience.id, audience.is_audience_activated)
            const data = await audienceMgmt.list();
            programAudiences = data;
            // Filter out expired first party segments before updating the modal
            // Use fresh first party data from API as source of truth
            const firstPartyData = await getFirstPartyDataForFiltering();
            const filteredAudiences = filterExpiredFirstPartySegments(programAudiences, firstPartyData);
            $scope.reactSegmentModals.loadAudience.programAudiences = filteredAudiences;
            $scope.disableLoadAudience = programAudiences.length === 0;
            $scope.$apply();
        }
    };
    
    $scope.reactSegmentModals = {
        lifestyle: {
            isOpen: false,
            newTitle: "Add a Lifestyle Segment",
            editTitle: "Modify Segment's Lifestyle",
            lifestyles: getLifestyles((context.current.audience_app || {}).current_channel || {}, debugUser)
        },

        '1st party': {
            isOpen: false,
            newTitle: "Select a 1st Party Segment",
            editTitle: "Modify Segment's 1st Party",
            onCancel: () => $scope.modalCancelHandler('1st party'),
        },

        loadAudience: {
            isOpen: false,
            newTitle: "Load a Program Audience",
            onCancel: () => {
                $scope.modalCancelHandler('loadAudience')
                $scope.loadAudienceSubmitHandler()
            },
            onSubmit: $scope.loadAudienceSubmitHandler,
            onDelete: $scope.deleteAudienceHandler,
        },

        'smartTvCommercials': {
            isOpen: false,
            newTitle: getNewCommercialsTitle(current_channel),
            editTitle: "Modify Segment's TV Commercial Viewership"
        },
        tvShows: {
            isOpen: false,
            newTitle: getNewTvShowsTitle(current_channel),
            editTitle: "Modify Segment's TV Viewership"
        },
        linkedinDemographics: {
            isOpen: false,
            newTitle: "Add a Demographic Segment",
            editTitle: "Modify Segment's Demographics",
            onCancel: () => $scope.modalCancelHandler('linkedinDemographics'),
            linkedinMetaDataPromise: linkedinMetaDataPromise,
        },
        linkedinIndustries: {
            isOpen: false,
            newTitle: "Add a Segment Based on Industries",
            editTitle: "Modify Segment's Industries",
            onCancel: () => $scope.modalCancelHandler('linkedinIndustries'),
            linkedinMetaDataPromise: linkedinMetaDataPromise,
        },
        country: {
            isOpen: false,
            newTitle: "Select a Country",
            editTitle: "Modify Segment's Country",
            allGeos: getAllGeos(),
            onCancel: () => $scope.modalCancelHandler('country'),
            type: 'country',
        },
    };
    $scope.reactSegmentModals.advancedTvShows = _.clone($scope.reactSegmentModals.tvShows);
    const hasUsGeoPermission = abiPermissions.hasPermission(PERMISSION.GEO_US);
    const hasSgTelcoEthnicityPermission = abiPermissions.hasPermission(PERMISSION.SG_TELCO_ETHNICITY);
    ['demographics', 'smartTvDemographics'].map((type) => {
        $scope.reactSegmentModals[type] = {
            isOpen: false,
            newTitle: "Add a Demographic Segment",
            editTitle: "Modify Segment's Demographics",
            allGeos: getAllGeos(),
            disableGeos: true,
            hasUsGeoPermission: hasUsGeoPermission && type === 'demographics',
            hasSgTelcoEthnicityPermission: hasSgTelcoEthnicityPermission && type === 'demographics',
            onCancel: () => $scope.modalCancelHandler(type),
            type,
        }
    });
    $scope.isActivateVisible = false;
    $scope.isActivateAudienceEnabled = false;
    $scope.isActivateAudienceVisible = false;
    $scope.isContextualUniquenessError = false;
    $scope.activateAudienceDisabledText = '';
    $scope.hasAmplificationModeSelector = common.hasAmplificationModeSelector(context, abiPermissions);
    $scope.hasFirstPartySegment = function() {
        return _.some($scope.audience.segment, { type: '1st party' });
    };
    $scope.hideAudiencePreview = false;
    $scope.showAudienceIpCount = false;

    $scope.unifiedTvSources = UNIFIED_TV_SOURCES;
    $scope.isUnifiedTvChannel = () =>
        context.current.audience_app.current_channel.value === CHANNELS.unified_tv?.name;
    $scope.perSourceActivation = {};
    $scope.perSourceHasData = {};
    // Retained but no longer read by the UI: the unified TV widget uses the page-channel single-source
    // handlers instead. Kept pending the deferred unified-TV activation-target decision (PHOB-1857 TBD).
    const perSourceHasDataHandlers = {};
    $scope.updateHasAudienceDataForSource = (sourceValue) => {
        if (!perSourceHasDataHandlers[sourceValue]) {
            perSourceHasDataHandlers[sourceValue] = (hasData) => {
                $scope.perSourceHasData[sourceValue] = hasData;
                $scope.updateHasAudienceData(Object.values($scope.perSourceHasData).some(Boolean));
            };
        }
        return perSourceHasDataHandlers[sourceValue];
    };

    // Set up user permissions array for React components
    $scope.userPermissions = [];
    if (abiPermissions.hasPermission('audience activation - always on')) {
        $scope.userPermissions.push('audience activation - always on');
    }
    if (abiPermissions.hasPermission(PERMISSION.TV_ACTIVATION)) {
        $scope.userPermissions.push(PERMISSION.TV_ACTIVATION);
    }

    setHideAudiencePreview(current_channel);
    setShowAudienceIpCount(current_channel);
    // PHOB-1857: contextual targeting is not offered for the unified TV channel (audience activation only),
    // so a US-only unified segment leaves the Activate button fully disabled.
    $scope.isActivateTargetEnabled = () => abiPermissions.hasPermission(PERMISSION.ACTIVE_TARGETS) &&
                                           current_channel !== CHANNELS.linkedin?.name &&
                                           current_channel !== CHANNELS.unified_tv?.name &&
                                           !isLimitedAudienceByCountry(current_channel);

    $scope.setContextualUniquenessError = (is_uniqueness_error) => {
        $scope.isContextualUniquenessError = is_uniqueness_error;
    }

    // PHOB-1857: same per-source channel requirement as activateAudienceForChannel above — the contextual
    // target's phrases/query must be built against the source's own channel, never 'unified_tv'. The
    // audience itself is still only ever stored under `current_channel` (context.current.audience_app is
    // keyed by the real channel, not by source), so `audience_name` intentionally keeps reading from there.
    function activateTargetForChannel(channel) {
        const segment = $scope.audience.segment;
        TargetsCommon.openAudienceContextualTarget({
            segment,
            channel,
            phrasesPromise: () => getSegmentInsightsData($scope.audience.segment, QUERY_NAMES.phrases, channel),
            query: getSegmentInsightsParams(segment, QUERY_NAMES[$scope.tab], channel),
            audience_name: context.current.audience_app[current_channel].audience_name,
            $scope,
            program_id: context.current.p_id
        });
    }

    $scope.handleActivatingTarget = () => activateTargetForChannel(current_channel);

    const perSourceActivatingTargetHandlers = {};
    $scope.handleActivatingTargetForSource = (sourceValue) => {
        if (!perSourceActivatingTargetHandlers[sourceValue]) {
            perSourceActivatingTargetHandlers[sourceValue] = () => activateTargetForChannel(sourceValue);
        }
        return perSourceActivatingTargetHandlers[sourceValue];
    };

    $scope.modalCancelHandler = (type) => {
        $scope.segmentType = null;
        const updatedReactSegmentModals = _.cloneDeep($scope.reactSegmentModals);
        updatedReactSegmentModals[type].isOpen = false;
        updatedReactSegmentModals.input = {};
        $scope.reactSegmentModals = updatedReactSegmentModals;
        $scope.$digest();
    };

    $scope.modalSubmitHandler = (values) => {
        $scope.segmentType = null;
        const segmentType = _.get(values, 'type');
        if (!segmentType) return;
        const segmentIndex = values.index;
        const updatedAudienceSegment = _.cloneDeep($scope.audience.segment);
        const updatedReactSegmentModals = _.cloneDeep($scope.reactSegmentModals);

        if (_.isNumber(segmentIndex) && segmentIndex >= 0) {
            const isSegmentChanged = !_.isEqual(updatedAudienceSegment[segmentIndex], values);
            const advancedTvGeoChanged = isSegmentChanged &&
                                         segmentType === 'country' &&
                                         CHANNELS[current_channel]?.isGeoMandatory &&
                                         values.geo !== updatedAudienceSegment[segmentIndex].geo;
            const segmentKeyDifferences = _.difference(Object.keys(updatedAudienceSegment[segmentIndex]), Object.keys(values));
            const updatedSegment = {..._.omit(updatedAudienceSegment[segmentIndex], segmentKeyDifferences), ...values};
            updatedAudienceSegment.splice(segmentIndex, 1, updatedSegment);
            $scope.audience.segment = _.reject(updatedAudienceSegment, (row) => advancedTvGeoChanged && row.type !== 'country');
            if (advancedTvGeoChanged) {
                $timeout(() => {
                    context.current.audience_app.default_geo = values.geo[0];
                    setDisabledSegmentTypes(current_channel)
                    setHideAudiencePreview(current_channel);
                    handleSmartTvCommercialsPromise({value: current_channel});
                })
            }
            refreshContext(isSegmentChanged);
        } else {
            const operand = $scope.advancedSegmentation ? $scope.filter.logicOperand[0] : $scope.logicalOperand;
            const newSegment = {operand, ...values};
            updatedAudienceSegment.push(newSegment);
            $scope.audience.segment = updatedAudienceSegment;
            if (current_channel === CHANNELS.linkedin?.name) disableEnableLinkedinSegments(segmentType);
            refreshContext(true);
        }

        updatedReactSegmentModals[segmentType].isOpen = false;
        $scope.reactSegmentModals = updatedReactSegmentModals;
        setShowAudienceIpCount(current_channel);
        $scope.$digest();
    };

    function getLifestyles(currentChannel, debugUser) {
        const lifestyles = filtersPartition.behavioralSegment.filter((segment) => segment.debugOnly ? debugUser : true);
        const channelLifestylesName = CHANNEL_TO_LIFESTYLE_NAME_MAP[currentChannel.value];
        const channelLifestyles = channelLifestylesName ? filtersPartition[channelLifestylesName].filter((segment) => segment.debugOnly ? debugUser : true) : [];
        return _.orderBy([...channelLifestyles, ...lifestyles], 'label', 'asc');
    }

    function getNewTvShowsTitle(currentChannel) {
        return "Add a segment based on " + getTvType(currentChannel) + " viewership";
    }

    function getNewCommercialsTitle(currentChannel) {
        return "Add a segment based on " + getTvCommercialType(currentChannel) + " commercial viewership";
    }

    function getAllGeos() {
        const addValueToGeo = (geo) => ({...geo, value: geo["id"]});
        const limitedGeos = CHANNELS[current_channel]?.limitedGeos && Object.keys(CHANNELS[current_channel]?.limitedGeos)
        if (limitedGeos?.length > 0) {
            return _.filter($scope.Geos.geos, (geo) => limitedGeos?.includes(geo.cc)).map(addValueToGeo);
        }
        return [ALL_GEOS].concat($scope.Geos.geos.map(addValueToGeo));
    }

    function updateModalLifestyles(channel) {
        if (!_.has($scope.reactSegmentModals, 'lifestyle.lifestyles')) return;
        $scope.reactSegmentModals.lifestyle.lifestyles = getLifestyles(channel, debugUser);
    }

    function updateModalTvShows(channel) {
        const title = getNewTvShowsTitle(channel);
        $scope.reactSegmentModals.tvShows.newTitle = title;
        $scope.reactSegmentModals.advancedTvShows.newTitle = title;
    }

    function updateModalCommercials(channel) {
        $scope.reactSegmentModals.smartTvCommercials.newTitle = getNewCommercialsTitle(channel);
    }

    function validateChannelContext() {
        $scope.audienceChannelsFilter = _.filter($scope.$root.audienceChannelsFilter, channel => (debugUser || !channel.debugOnly));
        if (!context.current.audience_app || !_.includes(_.map($scope.audienceChannelsFilter, 'value'), (context.current.audience_app.current_channel || {}).value)
            || (context.current.audience_app.current_channel.permission != null && !abiPermissions.hasPermission(context.current.audience_app.current_channel.permission))) {
            context.current.audience_app = {current_channel: common.getAvailableChannelFromContext($scope.audienceChannelsFilter, abiPermissions)};
        }
    }

    function removeTvShowsForWebChannel () {
        if (current_channel === CHANNELS.articles?.name) {
            if ($scope.audience.segment && _.isArray($scope.audience.segment)) {
                $scope.audience.segment = $scope.audience.segment.filter(segment => segment.type !== 'tvShows');
            }
            if (context.current.audience_app.articles.audience_segment && _.isArray(context.current.audience_app.articles.audience_segment)) {
                context.current.audience_app.articles.audience_segment = context.current.audience_app.articles.audience_segment.filter(segment => segment.type !== 'tvShows')
            }
        }
    }

    function loadFromContext() {
        current_channel = context.current.audience_app.current_channel.value;
        if (!context.current.audience_app[current_channel]) context.current.audience_app[current_channel] = {};
        let channel_audience = context.current.audience_app[current_channel];
        if (channel_audience.audience_activation?.deterministic &&
            !channel_audience.audience_activation.deterministic.is_dynamic) {
            _.each(_.filter(channel_audience.audience_segment,
                            (s) => (TV_SHOWS_SEGMENT_TYPES + COMMERCIALS_SEGMENT_TYPES).includes(s.type)),
                   (s) => delete s.timeframe);
        }

        $scope.audience = {
            id: channel_audience.audience_id || '',
            name: channel_audience.audience_name || '',
            segment: getSegmentWithAppliedMandatoryFields(channel_audience.audience_segment || []),
            activation: channel_audience.audience_activation,
            // PHOB-1857: restore the flat activated marker a unified TV parent carries instead of an
            // `activation` sub-doc, so isAudienceActivated() survives a channel switch (see
            // updateAudienceAppForChannel).
            is_activated: channel_audience.audience_is_activated,
            activated_at: channel_audience.audience_activated_at,
        };

        $scope.advancedSegmentation = channel_audience.audience_advancedSegmentation || false;
        $scope.isAudienceDeterministicActivated = channel_audience.is_audience_deterministic_activated || false;
        $scope.isAudienceAmplifiedActivated = channel_audience.is_audience_amplified_activated || false;
        $scope.isAudienceAlwaysOnActivated = channel_audience.is_audience_always_on_activated || false;
        // PHOB-1710: if this audience's amplified activation is still being created, resume polling
        // so the completion toast still fires after a reload. Deferred so the poller is initialized.
        ['amplified', 'always_on'].forEach((type) => {
            if (channel_audience.audience_activation?.[type]?.status === 'in_progress') {
                $timeout(() => $scope.pollActivationStatus($scope.audience.id, $scope.audience.name, type));
            }
        });
        $scope.activatedAmplifiedThreshold = channel_audience.activated_amplified_threshold || null;
        $scope.activatedAlwaysOnThreshold = channel_audience.activated_always_on_threshold || null;
        $scope.activatedMarket = channel_audience.activated_market;
        $scope.activatedAdvertiser = channel_audience.activated_advertiser;
        $scope.activatedDataContractId = channel_audience.activated_data_contract_id;
        $scope.activatedDataContractText = channel_audience.activated_data_contract_text;
        $scope.activatedCategoryId = channel_audience.activated_category_id;
        if (_.isEmpty(channel_audience.audience_logicalOperand)) {
            $scope.logicalOperand = $scope.logicalOperands[0];
        } else {
            $scope.logicalOperand = _.find($scope.logicalOperands, {value: channel_audience.audience_logicalOperand.value});
        }
        if (!$scope.advancedSegmentation) _.each($scope.audience.segment, (s) => s.operand = $scope.logicalOperand);
        if ($scope.reactSegmentModals) { //Only if this has been initialized
            DEMOGRAPHICS_SEGMENT_TYPES.forEach((segmentType) => {
                $scope.reactSegmentModals[segmentType].allGeos = getAllGeos();
            });
        }

        removeTvShowsForWebChannel();
    }

    $scope.onLogicalOperandChange = (selectedOperand) => {
        $scope.logicalOperand = selectedOperand;
        let newAudienceSegment = _.cloneDeep($scope.audience.segment);
        _.each(newAudienceSegment, (segment) => segment.operand = selectedOperand);
        $scope.audience.segment = newAudienceSegment;
        refreshContext(true);
    };

    $scope.onToggleAdvancedSegmentation = (isOn) => {
        MixpanelAudience.trackAdvancedSegmentation(context.current.audience_app.current_channel.value);
        if ($scope.isAudienceActivated()) return $scope.updateIsCloneAudienceOpen(true);
        if (!isOn) {
            const advancedOperands = _($scope.audience.segment).map('operand.value').uniq().value();
            if (advancedOperands.length === 1) {
                const operand = _.find($scope.logicalOperands, {value: advancedOperands[0] || 'and'});
                $scope.logicalOperand = operand ? operand : $scope.logicalOperand;
            }
            let newAudienceSegment = _.cloneDeep($scope.audience.segment);
            _.each(newAudienceSegment, (segment) => segment.operand = $scope.logicalOperand);
            const isSegmentChanged = !_.isEqual(newAudienceSegment, $scope.audience.segment);
            $scope.audience.segment = newAudienceSegment;
            refreshContext(isSegmentChanged);
        }
        $scope.advancedSegmentation = isOn;
    };

    $scope.loadAudience = () => {
        getConfirmation(true, async () => {
            // Open the modal immediately with the audiences we already have, so the user isn't
            // blocked on the slow fetches below (only needed to prune expired segments / refresh state).
            $scope.reactSegmentModals.loadAudience.programAudiences = programAudiences || [];
            $scope.reactSegmentModals.loadAudience.isOpen = true;
            $scope.$applyAsync();

            // PHOB-1710: re-fetch audiences from Mongo so freshly-activated segments show their current
            // state (e.g. "In Progress" / the amplified date) instead of the stale snapshot, then drop
            // audiences with expired first-party segments (fresh first-party data is the source of truth).
            const firstPartyData = await getFirstPartyDataForFiltering();
            const freshAudiences = (await getAudiencesForCurrentChannel(true)) || programAudiences || [];
            $scope.reactSegmentModals.loadAudience.programAudiences =
                filterExpiredFirstPartySegments(freshAudiences, firstPartyData);
            $scope.$applyAsync();
        });
    };

    // Handle load audience modal submission
    $scope.loadAudienceSubmitHandler = (value) => {
        $scope.reactSegmentModals.loadAudience.isOpen = false;
        
        // When the user uses browse back btn, there is no "segments" attribute.
        // We use this property as a validation, i.e. any valid response should include a "value" and segments" attribute.
        if (value && !_.isEmpty(value.segments)) {
            MixpanelAudience.trackLoadAudience(value.name, context.current.audience_app.current_channel.value);
            $scope.audience = {
                id: value.id,
                name: value.name,
                segment: getSegmentWithAppliedMandatoryFields(value.segments),
                activation: _.cloneDeep(value.activation),
                is_activated: value.is_activated,
                activated_at: value.activated_at,
            };
            originalAudienceName = value.name;
            $scope.advancedSegmentation = value.advancedSegmentation;
            $scope.isAudienceDeterministicActivated = !!value.activation?.deterministic;
            $scope.isAudienceAmplifiedActivated = !!value.activation?.amplified;
            $scope.isAudienceAlwaysOnActivated = !!value.activation?.always_on;
            // PHOB-1710: resume polling if the loaded audience's amplified activation is in progress.
            ['amplified', 'always_on'].forEach((type) => {
                if (value.activation?.[type]?.status === 'in_progress') {
                    $timeout(() => $scope.pollActivationStatus(value.id, value.name, type));
                }
            });
            $scope.activatedAmplifiedThreshold = value.activation?.amplified?.threshold;
            $scope.activatedAlwaysOnThreshold = value.activation?.always_on?.threshold;
            $scope.activatedMarket = value.activation?.market;
            $scope.activatedAdvertiser = value.activation?.advertiser;
            $scope.activatedDataContractId = value.activation?.data_contract_id;
            $scope.activatedDataContractText = value.activation?.data_contract_text;
            $scope.activatedCategoryId = value.activation?.category_id;
            $scope.logicalOperand = !$scope.advancedSegmentation && value.segments[0].operand ? value.segments[0].operand : $scope.logicalOperands[0];
            notificator.success({body: `"${$scope.audience.name}" audience loaded successfully`});
            clearNameErrors();
            refreshContext(true);
            removeTvShowsForWebChannel();
            syncCountryGatingFromLoadedSegment();
        }

        getAudiencesForCurrentChannel(true);
        if (current_channel === CHANNELS.linkedin?.name) disableEnableLinkedinSegments();
        setShowAudienceIpCount(current_channel);
    };

    $scope.onChannelFilterChange = (channelObj) => {
        if ($scope.isContextualUniquenessError) $scope.setContextualUniquenessError(false);
        context.current.audience_app.current_channel = channelObj;
        setHideAudiencePreview(channelObj.value);
        setShowAudienceIpCount(channelObj.value);
    };

    function getConfirmation(isLoad, callback) {
        if (!$scope.audienceDirty() || $scope.isAudienceActivated()) {
            callback();
        } else {
            const confirm = 'Continue without saving';
            const cancel = 'Cancel';
            const title = 'Audience unsaved';
            const msg = `Are you sure you want to ${isLoad ? 'load' : 'create'} a new audience
                         without saving your changes to this audience?`;

            confirmAction.getConfirmation(msg, confirm, cancel, title, 'audience-confirmation', true).then((modal) => {
                modal.close.then((confirmation) => {
                    if (confirmation === true) {
                        callback();
                    }
                });
            });
        }
    }

    function assignModalsProps(type, disableGeo) {
        if (DEMOGRAPHICS_SEGMENT_TYPES.includes(type)) {
            $scope.reactSegmentModals[type].channel = context.current.audience_app.current_channel.value;
            $scope.reactSegmentModals[type].defaultGeo = CHANNELS[context.current.audience_app.current_channel.value]?.isGeoMandatory ?
                                                           context.current.audience_app.default_geo : undefined;
        }

        if (type === 'linkedinDemographics' || type === 'linkedinIndustries') {
            $scope.reactSegmentModals[type].linkedinMetaDataPromise = linkedinMetaDataPromise;
        }

        if (ALL_DEMOGRAPHICS_SEGMENT_TYPES.includes(type)) {
            $scope.reactSegmentModals[type].disableGeos = disableGeo;
        }
    }

    $scope.audienceDirty = () => {
        const current_audience = _.find(programAudiences, {id: $scope.audience.id}) || {segments: [], name: '', advancedSegmentation: false};
        //  extract code duplication to sanitize 1st party segments
        const sanitize1stPartySegments = (segments) => segments.map(segment => {
            if (segment.type === '1st party') {
                return {...segment, segment_size: undefined, label: undefined}
            }
            return segment;
        });
        const current_audience_segments = sanitize1stPartySegments(current_audience.segments);
        const scope_audience_segment = sanitize1stPartySegments($scope.audience.segment);
        return angular.toJson(current_audience_segments) !== angular.toJson(scope_audience_segment)
            || current_audience.name !== $scope.audience.name
            || current_audience.advancedSegmentation !== $scope.advancedSegmentation;
    };

    $scope.resetAudience = (force = false) => {
        const cb = () => {
            MixpanelAudience.trackNewAudience({ channel: current_channel });
            $scope.audience = {name: '', segment: getSegmentWithAppliedMandatoryFields([])};
            originalAudienceName = '';
            $scope.advancedSegmentation = false;
            $scope.isAudienceDeterministicActivated = false;
            $scope.isAudienceAmplifiedActivated = false;
            $scope.isAudienceAlwaysOnActivated = false;
            $scope.activatedAmplifiedThreshold = null;
            $scope.activatedAlwaysOnThreshold = null;
            $scope.activatedMarket = null;
            $scope.activatedAdvertiser = null;
            $scope.activatedDataContractId = null;
            $scope.activatedDataContractText = null;
            $scope.activatedCategoryId = null;
            $scope.logicalOperand = $scope.logicalOperands[0];
            const audienceApp = context.current.audience_app[current_channel];
            audienceApp.audience_id = null;
            refreshContext(true);
            clearNameErrors();
            if (current_channel === CHANNELS.linkedin?.name) disableEnableLinkedinSegments();
            removeTvShowsForWebChannel();
            setShowAudienceIpCount(current_channel);
        }

        if (force) return cb();
        getConfirmation(false, cb);
    };

    $scope.deleteSegmentRow = (index) => {
        if ($scope.isSegmentRowWithoutDelete($scope.audience.segment[index])) return;
        if ($scope.isAudienceActivated()) return $scope.updateIsCloneAudienceOpen(true);
        let newAudienceSegment = _.cloneDeep($scope.audience.segment);
        let deletedSegmentRow = newAudienceSegment.splice(index, 1)[0];
        $scope.audience.segment = newAudienceSegment;
        disableEnableLinkedinSegments(deletedSegmentRow.type);
        refreshContext(true);
        setShowAudienceIpCount(current_channel);
    };

    $scope.editSegmentRow = (index) => {
        if ($scope.isAudienceActivated()) return $scope.updateIsCloneAudienceOpen(true);
        const type = $scope.audience.segment[index].type;
        $scope.segmentType = type;
        const modal = SEGMENT_MODAL_MAP[type];
        const disableGeo = ALL_DEMOGRAPHICS_SEGMENT_TYPES.includes(type) && _.filter($scope.audience.segment, (seg) => ALL_DEMOGRAPHICS_SEGMENT_TYPES.includes(seg.type)).length > 1;

        assignModalsProps(type, disableGeo);

        if (!modal) {
            $scope.reactSegmentModals[type].isOpen = true;
            $scope.reactSegmentModals[type].modalTitle = $scope.reactSegmentModals[type].editTitle;
            $scope.reactSegmentModals[type].input = {...$scope.audience.segment[index], index};
            return;
        }

        modal.showModal($scope.audience.segment[index], false, disableGeo, current_channel,
            {
                linkedinMetaDataPromise, abiPermissions, debugUser
            }).then((modal) => {
                modal.close.then((value) => {
                    $scope.segmentType = null;
                    // When the user uses browse back btn, there is no "type" attribute.
                    // We use this property as a validation, i.e. any valid response should include a "type" attribute.
                    if (value && value["type"]) {
                        let newAudienceSegment = _.cloneDeep($scope.audience.segment);
                        const isSegmentChanged = !_.isEqual(value, newAudienceSegment[index]);
                        newAudienceSegment[index] = value;
                        $scope.audience.segment = newAudienceSegment;
                        refreshContext(isSegmentChanged);
                    }
                });
            })
    };

    $scope.newSegmentRow = (type) => {
        if ($scope.isAudienceActivated()) return $scope.updateIsCloneAudienceOpen(true);
        $scope.segmentType = type;
        const modal = SEGMENT_MODAL_MAP[type];
        const prevDefinedDemographics = _.filter($scope.audience.segment, (seg) => ALL_DEMOGRAPHICS_SEGMENT_TYPES.includes(seg.type))[0] || {};
        const disableGeo = ALL_DEMOGRAPHICS_SEGMENT_TYPES.includes(type) && Object.keys(prevDefinedDemographics).length > 0;
        const initialDefinedProperties = disableGeo ? _.pick(prevDefinedDemographics, ['geo', 'states', 'ethnicity', 'income']) : null;

        assignModalsProps(type, disableGeo);

        MixpanelAudience.trackSegment(type, context.current.audience_app.current_channel.value);
        if (!modal) {
            $scope.reactSegmentModals[type].isOpen = true;
            $scope.reactSegmentModals[type].modalTitle = $scope.reactSegmentModals[type].newTitle;
            $scope.reactSegmentModals[type].input = ((type === 'demographics') && initialDefinedProperties) || {};
            return;
        }

        modal.showModal(initialDefinedProperties, true, disableGeo, current_channel,
            {
                linkedinMetaDataPromise, abiPermissions, debugUser
            }).then((modal) => {
                modal.close.then((value) => {
                    $scope.segmentType = null;
                    if (value?.type) {
                        value.operand = $scope.advancedSegmentation ? $scope.filter.logicOperand[0] : $scope.logicalOperand;
                        let newAudienceSegment = _.cloneDeep($scope.audience.segment);
                        newAudienceSegment.push(value);
                        $scope.audience.segment = newAudienceSegment;
                        setShowAudienceIpCount(current_channel);
                        refreshContext(true);
                        disableEnableLinkedinSegments(value["type"]);
                    }
                });
            });
    };

    let isNameCheckInProgress = false;
    async function isInvalidName() {
        const {audience: {id, name}} = $scope;
        const typedNameSnapshot = name;
        isNameCheckInProgress = true;
        $scope.name_missing = !name;
        if ($scope.name_missing) {
            isNameCheckInProgress = false;
            return true;
        }

        $scope.name_exist_in_program = await isNameExists(id, name);
        // Guard against unexpected resets while awaiting auth retry
        if (!$scope.audience.name && typedNameSnapshot) {
            $scope.audience.name = typedNameSnapshot;
        }
        isNameCheckInProgress = false;
        return $scope.name_exist_in_program;
    }

    async function isNameExists(id, name) {
        // PHOB-1710: read a FRESH, side-effect-free list. getAudiencesForCurrentChannel() returns a
        // cached promise, so rapid interaction could validate against a stale list and let a duplicate
        // name reach the backend, which rejects it (400 "Audience segment name ... already exists").
        // audienceMgmt.list() also avoids getProgramAudience()'s state-reconciliation side effects,
        // which can clobber an unsaved/just-cloned audience's local state.
        const audiences = await audienceMgmt.list();
        return !!audiences.find((a) => a.id !== id && a.name.toLowerCase() === name.toLowerCase());
    }

    async function isSensitiveName() {
        const {audience: {name}} = $scope;
        const {passed, text} = await checkNameSensitivity(name);
        $scope.name_is_insensitive = !passed;
        $scope.sensitiveTitleText = text;
        return $scope.name_is_insensitive;
    }

    function handleAudienceSensitivity(audience, props) {
        return new Promise(async (resolve, reject) => {
            try {
                const invalidName = await isSensitiveName();
                if (invalidName) return resolve({ canceled: true });

                if (!$scope.isActivateAudienceEnabled) return resolve({canceled: false, isDirty: false});

                const {
                    reviewSensitivityHandler,
                    sensitivityData,
                } = await checkSensitivity(audience, (newSegments) => {
                    if (newSegments) audience.segments = newSegments;

                    $scope.reviewSensitivity = { isOpen: false };
                    $scope.$apply();
                    resolve({ isDirty: !_.isEmpty(newSegments) });
                });

                if (_.isEmpty(sensitivityData)) return resolve({ isDirty: false });

                const cancelHandler = () => {
                    $scope.reviewSensitivity = { isOpen: false };
                    $scope.$apply();
                    resolve({ canceled: true });
                };
                $scope.reviewSensitivity = {
                    isOpen: true,
                    data: sensitivityData,
                    onCancel: cancelHandler,
                    onSubmit: reviewSensitivityHandler,
                    ...props,
                };
                $scope.$apply();
            } catch (e) {
                reject(e);
            }
        });
    }

    let saveInProcess = false;
    async function saveAudience(props) {
        if (saveInProcess) return { canceled: true };

        saveInProcess = true;
        try {
            const invalidName = await isInvalidName();
            if (invalidName) return { canceled: true };

            const audience = {
                name: $scope.audience.name,
                segments: _.cloneDeep($scope.audience.segment), // not sure why the audience has "segment" and not "segments"
                advancedSegmentation: $scope.advancedSegmentation,
                channel: current_channel,
            };
            const {canceled, isDirty} = [CHANNELS.smart_tv_inscape?.name, CHANNELS.tivo?.name, CHANNELS.articles?.name].includes(current_channel)
             ? await handleAudienceSensitivity(audience, props)
             : {canceled: false, isDirty: false};
            if (canceled) return { canceled: true };

            // skip saving of audience if there are no segments to save (because removing the sensitive ones cleared everything)
            $scope.audience.segment = audience.segments;
            if (_.isEmpty(audience.segments)) return { canceled: true };

            // skip saving of audience if it is not changed
            if (!isDirty && !$scope.audienceDirty()) return { canceled: false };

            const res = await (
              $scope.audience.id ? audienceMgmt.update($scope.audience.id, {data: audience}) : audienceMgmt.create({data: audience})
            );
            const rename = originalAudienceName && res.name !== originalAudienceName;
            const msg = rename ? `The audience "${originalAudienceName}" was renamed to "${audience.name}" and saved successfully`
                            : `The audience "${audience.name}" was saved successfully`;
            notificator.success({body: msg});
            await finalizeSave(res);
            return { canceled: false };
        } catch (e) {
            const msg = 'Failed saving audience';
            console.error(msg, e);
            notificator.error({ body: msg });
            return { canceled: true };
        } finally {
            saveInProcess = false;
        }
    }

    function trackSaveAudience(segments) {
        const inputSegments = segments.map(
          ({required = [], included = []}) => [
              ...required.map(sr => sr.text),
              ...included.map(si => si.text),
          ]
        );
        const trackProps = {
            channel: current_channel,
            program: context.program.name,
            segment: (context.current.audience_app || {})[current_channel],
            "input segments": inputSegments
        };
        MixpanelAudience.trackSaveAudience(trackProps);
    }

    function finalizeSave(audience) {
        $scope.audience.id = audience.id;
        $scope.audience.name = audience.name;
        trackSaveAudience(audience.segments);
        refreshContext(false);
        clearNameErrors();
        return getAudiencesForCurrentChannel(true);
    }

    $scope.saveAudience = () => {
        return saveAudience({
            title: 'Review before saving',
            keepPhrasesText: 'Save Audience',
            removePhrasesText: 'Remove & Save',
        });
    };

    async function checkDemographicsData(segment, options) {
        const size = await getAudienceSize(segment, options);
        if (isAudienceSizeTooSmall(size)) {
            notificator.error('Your audience is too narrow and cannot be activated. Please refine your audience.');
            return false;
        }
        return true;
    }

    async function checkName(id, name) {
        if (!name) return { isValid: false };

        const nameExists = await isNameExists(id, name);
        if (nameExists) return {
            error: `The name "${name}" already exists. Please choose a different name.`,
            isValid: false,
        };

        const {passed, text} = await checkNameSensitivity(name);
        if (!passed) return { error: text, isValid: false };

        return { isValid: true };
    }

    function getAudienceName(id, origName) {
        return new Promise(async (resolve) => {
            const { isValid, error } = await checkName(id, origName);
            if (isValid) {
                return resolve({ name: origName });
            }

            $scope.audienceNameProps = {
                isOpen: true,
                origName,
                origErrorMessage: error,
                checkName: (name) => checkName(id, name),
                onCancel() {
                    $scope.audienceNameProps = { isOpen: false };
                    $scope.$apply();
                    resolve({ canceled: true });
                },
                onSubmit(name) {
                    $scope.audienceNameProps = { isOpen: false };
                    $scope.$apply();
                    resolve({ name });
                },
            };
            // Activation is invoked from the React AudienceTarget, i.e. outside an Angular digest, so
            // opening the name-conflict modal here must schedule a digest — otherwise the modal state is
            // set but never rendered (the caller's spinner then hangs with no visible dialog). $applyAsync
            // is used so it is a no-op-safe schedule whether or not a digest is already running.
            $scope.$applyAsync();
        });
    }

    // PHOB-1857: the pre-activation size check must be built exactly as if the audience was created on
    // `channel` — for the unified_tv panels that means the source's own channel (hisense/peerlogix), never
    // 'unified_tv' itself (there is no such backend contract). `channel` is threaded through explicitly
    // rather than closing over `current_channel` so each per-source handler queries its own contract.
    async function activateAudienceForChannel(channel) {
        const {audience: {id, name: origName}} = $scope;
        const {name, canceled: nameCanceled} = await getAudienceName(id, origName);
        if (nameCanceled) return { canceled: true };

        $scope.audience.name = name;
        const { canceled: saveCanceled } = await saveAudience({
            title: 'Review before activating',
            keepPhrasesText: 'Activate Audience',
            removePhrasesText: 'Remove & Activate',
        });
        if (saveCanceled) return { canceled: true };

        // PHOB-1857: unified TV activates a separate per-source audience (ACR / Streaming), so the
        // pre-activation size gate runs once per source channel (hisense/peerlogix) rather than once for
        // 'unified_tv'. Each get-segment-ids call then carries that source's own filter-mapping, countries
        // token, and table (e.g. bid_stream_hisense/hisense_media vs bid_stream_peerlogix/peerlogix_media).
        // We block only when EVERY source is too narrow — consistent with the Activate button's enablement,
        // which is enabled when ANY source can be activated (see updateAudienceAppForChannel). Otherwise a
        // single narrow source would leave the menu item enabled but silently swallow the click.
        const sizeCheckChannels =
            channel === CHANNELS.unified_tv?.name
                ? getUnifiedTvActivatableSources($scope.audience.segment)
                : [channel];
        const demographicsResults = await Promise.all(
            sizeCheckChannels.map((sizeCheckChannel) => {
                const isBidstream = sizeCheckChannel === CHANNELS.articles?.name || sizeCheckChannel === 'bidstream';
                return checkDemographicsData($scope.audience.segment, {
                    channel: sizeCheckChannel,
                    userId,
                    isBidstream,
                    minimalSize: 150,
                    filterBidstreamDomains: isBidstream,
                });
            })
        );
        if (demographicsResults.every((isOk) => !isOk)) return { canceled: true };

        return {
            audienceId: $scope.audience.id,
            audienceName: $scope.audience.name,
            // PHOB-1710: return the freshly-resolved activation state (read from live $scope here, so it
            // is never stale) so AudienceTarget can pass it to the modal directly. react2angular does
            // not reliably propagate these primitives to the already-rendered component, so the modal
            // otherwise mounts with stale "already activated" props (e.g. a clone shows its source's
            // always-on data contract and a disabled Activate button).
            activationState: {
                isAudienceDeterministicActivated: $scope.isAudienceDeterministicActivated,
                isAudienceAmplifiedActivated: $scope.isAudienceAmplifiedActivated,
                isAudienceAlwaysOnActivated: $scope.isAudienceAlwaysOnActivated,
                activatedAmplifiedThreshold: $scope.activatedAmplifiedThreshold,
                activatedAlwaysOnThreshold: $scope.activatedAlwaysOnThreshold,
                activatedMarket: $scope.activatedMarket,
                activatedAdvertiser: $scope.activatedAdvertiser,
                activatedDataContractId: $scope.activatedDataContractId,
                activatedDataContractText: $scope.activatedDataContractText,
                activatedCategoryId: $scope.activatedCategoryId,
            },
        };
    }

    $scope.handleActivatingAudience = () => activateAudienceForChannel(current_channel);

    // Mirrors the `perSourceHasDataHandlers` memoization above: react2angular re-renders whenever a prop's
    // function identity changes, so a fresh closure per digest would loop. One memoized handler per source.
    const perSourceActivatingAudienceHandlers = {};
    $scope.handleActivatingAudienceForSource = (sourceValue) => {
        if (!perSourceActivatingAudienceHandlers[sourceValue]) {
            perSourceActivatingAudienceHandlers[sourceValue] = () => activateAudienceForChannel(sourceValue);
        }
        return perSourceActivatingAudienceHandlers[sourceValue];
    };

    // onClose must be defined from the initial (closed) mount too — the react2angular component declares
    // it required, so a stable handler is set on the initial props object, not only when the popup opens.
    const closeNewAudiences = () => {
        $scope.newAudiencesProps = { ...$scope.newAudiencesProps, isOpen: false };
        $scope.$applyAsync();
    };
    $scope.newAudiencesProps = { isOpen: false, audiences: [], onClose: closeNewAudiences };

    $scope.showNewAudiences = (audiences) => {
        // PHOB-1857: this fires on unified TV activation success. The parent is now split/dispatched and
        // must go read-only + clone-only immediately, not only after a reload. isAudienceActivated() keys
        // off the flat is_activated/activated_at (which syncActivationStateFromAudience restores on reload),
        // so mark them in-memory here too. activated_at just needs to be truthy for the guard; the real DB
        // value replaces it on the next load.
        if ($scope.audience) {
            $scope.audience.is_activated = true;
            $scope.audience.activated_at = new Date().toISOString();
            // Marking the audience is not enough for the Activate button: it is driven by
            // $scope.isActivateAudienceEnabled, which is only recomputed by
            // updateAudienceAppForChannel (isActivateAudienceEnabled() keys off activated_at).
            // Same pattern as the update*Activated handlers below — without this the button stays
            // clickable until a reload, offering a second activation of an already-split parent.
            updateAudienceAppForChannel(current_channel, $scope.audience, false);
        }
        $scope.newAudiencesProps = { isOpen: true, audiences, onClose: closeNewAudiences };
        $scope.$applyAsync();
    };

    $scope.clearNameErrors = clearNameErrors;

    function clearNameErrors() {
        $scope.name_exist_in_program = false;
        $scope.name_missing = false;
        $scope.name_is_insensitive = false;
        $scope.sensitiveTitleText = '';
        $scope.cloned_audience_name_auto_generated = false;
    }

    let programAudiences = [];

    function getAudiencesForCurrentChannel(force = false) {
        const audienceApp = context.current.audience_app[current_channel];

        // the best way to check if a value is a promise
        // https://stackoverflow.com/questions/27746304/how-do-i-tell-if-an-object-is-a-promise/38339199#38339199
        if (force || Promise.resolve(audienceApp.getProgramAudiencePromise) !== audienceApp.getProgramAudiencePromise) {
            audienceApp.getProgramAudiencePromise = getProgramAudience(current_channel);
        }

        return audienceApp.getProgramAudiencePromise;
    }

    // PHOB-1710: reconcile the loaded audience's activation state from fresh Mongo data. The
    // restored context snapshot can be stale (it's saved on a 3s debounce, so activating then
    // refreshing right away restores the pre-activation state) — which would let the user
    // re-activate and hit a "already active" 400. Mongo is the source of truth for activation.
    function syncActivationStateFromAudience(audience) {
        $scope.audience.activation = audience.activation;
        // PHOB-1857: a unified TV parent is marked activated with flat is_activated/activated_at (no
        // `activation` sub-doc). Carry them from the fresh DB audience so the reload/context-restore path
        // (not just the Load-Audience modal) makes isAudienceActivated() true -> read-only + clone-only.
        $scope.audience.is_activated = audience.is_activated;
        $scope.audience.activated_at = audience.activated_at;
        $scope.isAudienceDeterministicActivated = !!audience.activation?.deterministic;
        $scope.isAudienceAmplifiedActivated = !!audience.activation?.amplified;
        $scope.isAudienceAlwaysOnActivated = !!audience.activation?.always_on;
        $scope.activatedAmplifiedThreshold = audience.activation?.amplified?.threshold;
        $scope.activatedAlwaysOnThreshold = audience.activation?.always_on?.threshold;
        $scope.activatedMarket = audience.activation?.market;
        $scope.activatedAdvertiser = audience.activation?.advertiser;
        $scope.activatedDataContractId = audience.activation?.data_contract_id;
        $scope.activatedDataContractText = audience.activation?.data_contract_text;
        $scope.activatedCategoryId = audience.activation?.category_id;
        updateAudienceAppForChannel(current_channel, $scope.audience, false);
        ['amplified', 'always_on'].forEach((type) => {
            if (audience.activation?.[type]?.status === 'in_progress') {
                $timeout(() => $scope.pollActivationStatus($scope.audience.id, $scope.audience.name, type));
            }
        });
    }

    async function getProgramAudience(channel) {
        const audienceApp = context.current.audience_app[channel];
        programAudiences = await audienceMgmt.list();
        // PHOB-1710: identify the current audience by ID, not name. A new/just-cloned audience has no
        // id; matching purely by name lets it adopt a sibling's id + activation (e.g. a "_copy" sharing
        // the base name), re-applying that activation and showing the activate modal as already-active.
        // Fall back to name only for a non-clone that has no id yet (stale-context restore).
        const isFreshClone = !$scope.audience.id && $scope.cloned_audience_name_auto_generated;
        const currentAudience = (
            $scope.audience.id
                ? (programAudiences || []).find((a) => a.id === $scope.audience.id)
                : (isFreshClone ? undefined : _.find(programAudiences, {name: $scope.audience.name}))
        ) || {};
        $scope.audience.id = currentAudience.id;
        originalAudienceName = currentAudience.name;
        $scope.disableLoadAudience = programAudiences.length === 0;
        // Trust Mongo's activation state over the (possibly stale) restored snapshot.
        if (currentAudience.id) syncActivationStateFromAudience(currentAudience);
        // map audience ids to names, for later display
        audienceApp.audience_ids = programAudiences.reduce((obj, aud) => {
            obj[aud.id] = aud.name;
            return obj;
        }, {});
        audienceApp.audience_id = currentAudience.id;
        return programAudiences;
    }

    async function updateAudienceAppForChannel(channel, audience, isSegmentChanged) {
        context.current.audience_app[channel] = {
            ...context.current.audience_app[channel],
            audience_targetDisabled: !$scope.hasAudienceData,
            is_activate_target_enabled: $scope.isActivateTargetEnabled(),
            is_audience_deterministic_activated: $scope.isAudienceDeterministicActivated,
            is_audience_amplified_activated: $scope.isAudienceAmplifiedActivated,
            is_audience_always_on_activated: $scope.isAudienceAlwaysOnActivated,
            activated_amplified_threshold: $scope.activatedAmplifiedThreshold,
            activated_always_on_threshold: $scope.activatedAlwaysOnThreshold,
            activated_market: $scope.activatedMarket,
            activated_advertiser: $scope.activatedAdvertiser,
            activated_data_contract_id: $scope.activatedDataContractId,
            activated_data_contract_text: $scope.activatedDataContractText,
            activated_category_id: $scope.activatedCategoryId,
            // PHOB-1857: a unified TV parent is marked activated with the FLAT is_activated/activated_at
            // (it has no `activation` sub-doc, so the is_audience_*_activated flags above all stay false).
            // Those two must be part of the per-channel context like every other activation flag —
            // loadFromContext() rebuilds $scope.audience from here on every channel switch, so without
            // them, leaving unified TV and coming back loses the marker: isAudienceActivated() flips back
            // to false, Clone Audience is disabled again and Activate re-enabled, and clicking it PUTs the
            // (activated, hence read-only) parent, which abi-mgmt rejects with "cannot be edited".
            audience_is_activated: audience?.is_activated,
            audience_activated_at: audience?.activated_at,
            is_audience_dirty: $scope.audienceDirty(),
            finalizeSave: finalizeSave,
        };
        $scope.isActivateAudienceEnabled = false;
        $scope.activateAudienceDisabledText = '';
        $scope.perSourceActivation = {};
        if (channel === CHANNELS.unified_tv?.name) {
            // Unified TV has no backend size/activation contract of its own — a get-segment-ids call with
            // channel 'unified_tv' degrades to a generic `us` query with no source filter-mapping (geoByChannel
            // has no unified_tv case). So we never check 'unified_tv' directly: enablement is computed per real
            // source (hisense/peerlogix, each producing its own bid_stream_<source> size call) and rolled up to
            // the page-level flags that drive the single Activate button.
            // A source is enabled only if it has an audience — its own shows or any shared non-geo
            // attribute. A US-only segment has no activatable source, so nothing is checked and the
            // rollup below leaves the Activate button disabled.
            for (const sourceValue of getUnifiedTvActivatableSources(audience.segment)) {
                const sourceResult = await isActivateAudienceEnabled(abiPermissions, sourceValue, audience, userId);
                $scope.perSourceActivation[sourceValue] = {
                    isEnabled: sourceResult.isEnabled,
                    isVisible: sourceResult.isVisible,
                    disabledText: sourceResult.disabledText,
                    isActivateVisible: sourceResult.isVisible || $scope.isActivateTargetEnabled(),
                };
            }
            const sourceResults = Object.values($scope.perSourceActivation);
            $scope.isActivateAudienceEnabled = sourceResults.some((result) => result.isEnabled);
            $scope.isActivateAudienceVisible = sourceResults.some((result) => result.isVisible);
            $scope.activateAudienceDisabledText = $scope.isActivateAudienceEnabled
                ? ''
                : (sourceResults.find((result) => result.disabledText) || {}).disabledText || '';
        } else {
            const {isEnabled, isVisible, disabledText} = await isActivateAudienceEnabled(abiPermissions, channel, audience, userId);
            $scope.isActivateAudienceEnabled = isEnabled;
            $scope.isActivateAudienceVisible = isVisible;
            $scope.activateAudienceDisabledText = disabledText;
        }
        $scope.isActivateVisible = $scope.isActivateAudienceVisible || $scope.isActivateTargetEnabled();
        if ($scope.isContextualUniquenessError) $scope.setContextualUniquenessError(!isSegmentChanged)
        // $applyAsync (not $digest): for a unified US-only segment getUnifiedTvActivatableSources() is
        // empty, so the loop above awaits nothing and this runs synchronously inside the caller's digest.
        // $applyAsync schedules a digest safely whether or not one is already in progress (avoids
        // $rootScope:inprog), and coalesces with the surrounding digest.
        $scope.$applyAsync();
    }

    getAudiencesForCurrentChannel(true);
    const unbindContextListener = context.onChange((newVal, oldVal) => {
        if (oldVal && newVal.p_id === oldVal.p_id) return;
        clearNameErrors();
        loadFromContext();


        getAudiencesForCurrentChannel();
    });

    $scope.$on('$destroy', unbindContextListener);
    $scope.refreshContext = refreshContext;

    async function refreshContext(isSegmentChanged, channel = current_channel) {
        const channelAudience = context.current.audience_app[channel];
        channelAudience.audience_segment = _.cloneDeep($scope.audience.segment);
        channelAudience.audience_activation = _.cloneDeep($scope.audience.activation);
        channelAudience.audience_name = $scope.audience.name;
        channelAudience.audience_id = $scope.audience.id;
        channelAudience.audience_advancedSegmentation = $scope.advancedSegmentation;
        channelAudience.audience_logicalOperand = _.cloneDeep($scope.logicalOperand);
        delete channelAudience.audience_interestsToTest;
        await updateAudienceAppForChannel(channel, $scope.audience, isSegmentChanged);
    }

    const nameInput = angular.element(document.querySelector('.segment-name'));
    const inputFont = nameInput.css('font');

    $scope.rename = (onBlur) => {
        if (saveInProcess) return;
        if (!onBlur) document.querySelector('.segment-name').blur();
        if ($scope.audience.name === originalAudienceName || $scope.audience.segment.length === 0) return;
        $scope.saveAudience();
    };

    $scope.calcAsteriskLeft = () => 38 + common.getTextWidth($scope.audience.name, inputFont) * 1.4;

    function getTooltipOffsets(index, textLength) {
        let elemWidth = $(".audience-builder").width();
        let limit = ($rootScope.filterMenuOpen ? 800 : 1035);
        let offset = _.max([(elemWidth - limit), 0]);
        return {x: (offset / 10) * index - textLength, y: elemWidth > limit + 200 ? -20 : -50};
    }

    $scope.getSegmentValuesSummary = (segment) => getSegmentValuesSummary(segment, filtersPartition);

    // PHOB-1857: unified TV segments render one summary row per source, so the row grows taller and needs
    // the type label + action buttons vertically centered (see .multi-source-segment styles).
    $scope.isMultiSourceSegment = (segmentRow) =>
        Array.isArray(segmentRow.sources) && segmentRow.sources.length > 1;

    $scope.onLogicOperandChange = (segment, value, index) => {
        if ($scope.isAudienceActivated()) return $scope.updateIsCloneAudienceOpen(true);
        const clonedAudienceSegment = _.cloneDeep($scope.audience.segment);
        // Because the operand is changed mutably by the am-input, the prevProps and currentProps are the same, thus
        // widget update is not triggered
        clonedAudienceSegment[index].immutableOperand = value;
        $scope.audience.segment = clonedAudienceSegment;
        refreshContext(true);
    };

    // When you switch to a new program on audience_builder page.
    $scope.$watch('context.program', () => {
        if (context.current.audience_app) return;
        context.current.audience_app = {current_channel: $scope.audienceChannelsFilter.find(channel => channel.value === current_channel)};
        loadFromContext();
        getAudiencesForCurrentChannel();
    });

    $scope.$watch('context.current.audience_app.current_channel', channelChanged);
    $scope.$watch('context.current.program', channelChanged);
    $($window).on("resize", recreateTooltips);
    let isRedirected = false;

    function channelChanged(newChannel = {}, oldChannel = {}) {
        if (_.isEmpty(newChannel) && _.isEmpty(oldChannel)) return;
        setDisabledFirstPartyModalValue(true, newChannel.value);
        $scope.channelAuthorized = false;
        const channelParam = $stateParams.channel || $location.search().channel;

        if (channelParam) {
            // In UI-Router 1.x, $stateParams is read-only. Use $state.go() to update params
            const params = angular.copy($stateParams);
            delete params.channel;
            $state.go($state.current.name, params, { location: 'replace', notify: false });
            if ($location.search().hasOwnProperty('channel')) $location.search('channel', null);
            isRedirected = true;
            context.current.audience_app[current_channel].getProgramAudiencePromise = undefined;
            return validateChannelFromFilters(channelParam);
        }

        $scope.hasAmplificationModeSelector = common.hasAmplificationModeSelector(context, abiPermissions);
        $scope.channelFilterSideMenuSelectedChannel = $scope.audienceChannelsFilter.find((channel) => channel.value === context.current.audience_app.current_channel.value);
        channelAuthorizationCheck(newChannel).then((authorizationStatus) => {
            if (!authorizationStatus) return;
            if (!authorizationStatus.authorized) return handleChannelNotAuthorized(newChannel, oldChannel, authorizationStatus.error);
            // Show the builder immediately — the 1st-party fetch kicked off below must not
            // gate the whole channel UI (it has its own isLoading state on the modal). PHOB-1559 regression.
            $scope.channelAuthorized = true;
            if ([CHANNELS.articles?.name, CHANNELS.bidstream?.name].includes(newChannel.value)) handleArticlesChannel(newChannel);
            else if (isSmartTvChannel(newChannel.value) && !isAdvancedTvChannel(newChannel.value)) handleSmartTvChannel(newChannel);
            else if (isAdvancedTvChannel(newChannel.value)) handleAdvancedTvChannel(newChannel);
            if (newChannel.value === CHANNELS.linkedin?.name) linkedinMetaDataPromise = getLinkedinMetaData(context.current.u_id);
            if (newChannel.value === oldChannel.value) return;
            changeSegmentTypes(newChannel.value);
            updateModalLifestyles(newChannel);
            updateModalTvShows((newChannel || {}).value);
            updateModalCommercials((newChannel || {}).value);
            if (isRedirected || $rootScope.programChanged) {
                isRedirected = false;
                $rootScope.programChanged = false;
            } else {
                refreshContext(true, oldChannel.value);
            }
            loadFromContext();
            getAudiencesForCurrentChannel();
            setShowAudienceIpCount(current_channel);
        })
    }

    function setDisabledFirstPartyModalValue(value, channel) {
        $scope.noFirstPartySegments = value;
        setDisabledSegmentTypes(channel);
    }

    function removeNoSegmentsTooltips() {
        $(".qtip.no-segments").remove();
    }

    function channelAuthorizationCheck(channel) {
        let tokenStatus = $stateParams.tokenStatus;
        // In UI-Router 1.x, $stateParams is read-only. Use $state.go() to update params
        if (tokenStatus !== undefined && tokenStatus !== null) {
            const params = angular.copy($stateParams);
            delete params.tokenStatus;
            $state.go($state.current.name, params, { location: 'replace', notify: false });
        }
        if (channel.value === CHANNELS.linkedin?.name) return validateUserAuthentication(context.current.u_id, tokenStatus, errorMgmt);
        return Promise.resolve({authorized: true});
    }

    function handleChannelNotAuthorized(newChannel, oldChannel, error) {
        console.info(`could not switch to ${newChannel.value} channel: ${error}`);
        context.current.audience_app.current_channel = $scope.audienceChannelsFilter.find(channel => channel.value === CHANNELS.articles?.name);
        $scope.channelFilterSideMenuSelectedChannel = context.current.audience_app.current_channel;
    }

    function disableEnableLinkedinSegments(type) {
        if (current_channel === CHANNELS.linkedin?.name && type) {
            let relevantSegmentType = LINKEDIN_SEGMENT_TYPES.find(segmentType => segmentType.value === type);
            Object.assign(relevantSegmentType, {isDisabled: !relevantSegmentType.isDisabled});
        } else {
            let segments = ((context.current.audience_app.linkedin || []).audience_segment || []).map(segment => segment.type);
            LINKEDIN_SEGMENT_TYPES.forEach((linkedinSegmentType) => {
                Object.assign(linkedinSegmentType, {isDisabled: segments.includes(linkedinSegmentType.value)});
            });
        }
        changeSegmentTypes(current_channel);
    }
    
    function getLimitedGeosBy(channel,limitedKey){
        return Object.keys(CHANNELS[channel]?.limitedGeos).filter((cc) => CHANNELS[channel].limitedGeos[cc][limitedKey]?.length)
    }

    function isLimitedAudienceByCountry(channel) {
        if(channel === CHANNELS.hisense?.name){
            return getLimitedGeosBy(channel,'disabledSegments')?.includes(context?.current?.audience_app?.default_geo?.cc);
        }
    }

    function setHideAudiencePreview(channel) {
        $scope.hideAudiencePreview = isLimitedAudienceByCountry(channel);
    }

    // Loading an audience swaps in its segment (incl. its Country row) but never re-synced
    // default_geo, so the country-gated view (disabled segment types + hidden Explore Audience)
    // kept the geo the user last picked in the Country modal. Loading a US audience right after
    // selecting a restricted geo (France/AU/CA/DE) therefore rendered that geo's restrictions on
    // the US audience. Re-sync default_geo from the loaded Country row, then recompute the gates.
    // PHOB-1813 follow-up.
    function syncCountryGatingFromLoadedSegment() {
        if (!CHANNELS[current_channel]?.isGeoMandatory) return;
        const loadedGeo = getCountryGeoFromSegment($scope.audience.segment);
        if (loadedGeo) context.current.audience_app.default_geo = loadedGeo;
        setDisabledSegmentTypes(current_channel);
        setHideAudiencePreview(current_channel);
    }
    
    function setShowAudienceIpCount(channel) {
        $scope.showAudienceIpCount = isSmartTvChannel(channel) &&
          abiPermissions.hasPermission(showAudienceIpCountPermissionName) &&
          $scope.allowDeterministicSegment && ($scope.audience.segment.length > 0 );
    }
    
    function isDisabledSegmentTypeByChannelAndCountry(channel, segmentTypeValue, countryCode) {
        return isLimitedAudienceByCountry(channel) && CHANNELS[channel].limitedGeos[countryCode]?.disabledSegments?.includes(segmentTypeValue);
    }
    
    function isDisabledSegmentTypeByPermission(segmentTypeValue) {
        return !!(abiPermissions.hasPermission(PERMISSION.SMART_TVA_LITE) && [SEGMENT_ROW_TYPES.INTERESTS.value, SEGMENT_ROW_TYPES.WEBSITES.value].includes(segmentTypeValue));
    }

    function setDisabledSegmentTypes(channel) {
        const defaultTooltipMsg = 'Contact your Nexxen Account Manager to learn more about advanced insights-to-activation.';
        $scope.segmentTypes = $scope.segmentTypes.map((segment) => {
            const isDisabledByChannelAndCountry = isDisabledSegmentTypeByChannelAndCountry(channel, segment.value,context?.current?.audience_app?.default_geo?.cc );
            if (segment.value === SEGMENT_ROW_TYPES.FIRST_PARTY.value) {
                return $scope.noFirstPartySegments || isDisabledByChannelAndCountry ? {
                        ...segment,
                        isDisabled: true,
                        tooltip: isLimitedAudienceByCountry(channel) ? defaultTooltipMsg : 'No segments applied for this program'
                    }
                    : _.omit(segment, ['isDisabled', 'tooltip']);
            }
            if (isSmartTvChannel(channel)) {
                const isDisabled = isDisabledSegmentTypeByPermission(segment.value) || isDisabledByChannelAndCountry;
                return {
                    ...segment,
                    isDisabled,
                    tooltip: isDisabled && defaultTooltipMsg,
                };
            }

            return segment;
        });
        recreateTooltips();
    }

    function recreateTooltips() {
        removeNoSegmentsTooltips();
        _.each($scope.segmentTypes, (segment, i) => {
            if (segment.tooltip) {
                let offsets = getTooltipOffsets(i, segment.tooltip.length);
                let element = $("toggle-button." + _.snakeCase(segment.value));
                let options = {
                    prerender: true,
                    position: {
                        at: 'center',
                        adjust: offsets
                    },
                    style: {classes: "no-segments common-tooltip-info"}
                };
                add_tooltip(element, 'info', options);
            }
        });
    }

    function debugOnlySegmentsOmitKeys(segments, debugUser) {
        return _.map(segments, (segment) => (
            debugUser && segment.debugOnly ? _.omit(segment, ['isDisabled', 'tagLabel']) : segment
        ));
    }

    function changeSegmentTypes(channel) {
        $scope.segmentTypes = channelToSegmentTypes[channel];
        $scope.segmentTypes = $scope.segmentTypes.filter((segmentType) =>
            segmentType.debugOnly ? (debugUser || segmentType.tagLabel) :
                (!segmentType.permission || abiPermissions.hasPermission(segmentType.permission))
        );
        $scope.segmentTypes = debugOnlySegmentsOmitKeys($scope.segmentTypes, debugUser);
        setDisabledSegmentTypes(channel);
    }

    function validateFirstPartySegmentContext() {
        if (abiPermissions.hasPermission(PERMISSION.FIRST_PARTY_SEGMENT) || !_.has(context.current.audience_app, 'articles.audience_segment')) return;
        context.current.audience_app.articles.audience_segment = _.reject(context.current.audience_app.articles.audience_segment, ['type', '1st party']);
    }

    async function handleFirstPartySegments (newChannel) {
        if (abiPermissions.hasPermission(PERMISSION.FIRST_PARTY_SEGMENT)) {
            $scope.reactSegmentModals['1st party'].isLoading = true;
            try {
                const data = await getFirstPartyDataByProgram(
                    context.program, 
                    { shouldFetchSegmentSizes: true }
                );
                // Filter out segments with pending expiration from audience selection
                const activeSegments = data.filter(segment => {
                    if (segment.pending_expiration) { 
                        return false;
                    }
                    
                    return true;
                });
                // replace  1st party segments in $scope.audience.segment is 1st party segment in data
                updateFirstPartySegments($scope.audience.segment, data);
                setDisabledFirstPartyModalValue(_.isEmpty(activeSegments), newChannel.value);
                $scope.reactSegmentModals['1st party'].isLoading = false;
                $scope.segments = activeSegments;
            } catch (error) {
                $scope.reactSegmentModals['1st party'].isLoading = false;
                // Error will be handled by existing error handling in getFirstPartyDataByProgram
            }
        }
    }

    function handleArticlesChannel (newChannel) {
        handleFirstPartySegments(newChannel);
        if ($scope.hasActivateAudiencePermission(newChannel.value)) $scope.marketsAndAdvertisersPromise = dspService.getAmplificationMarketContext('value');
    }

    function handleSmartTvChannel (newChannel) {
        handleSmartTvCommercialsPromise(newChannel);
        handleFirstPartySegments(newChannel);
        startTvMetadataPromises(newChannel);
    }

    function handleAdvancedTvChannel (newChannel) {
        handleSmartTvCommercialsPromise(newChannel);
        handleFirstPartySegments(newChannel);
        $scope.reactSegmentModals['advancedTvShows'].tvGenresMetadataPromise = getAdvancedTvGenresMetaData();
        if ($scope.hasActivateAudiencePermission(newChannel.value)) $scope.marketsAndAdvertisersPromise = dspService.getAmplificationMarketContext('value');
    }

    function handleSmartTvCommercialsPromise (newChannel) {
        let commercialsParams = [newChannel.value];
        if (CHANNELS[newChannel.value]?.isGeoMandatory) {
            context.current.audience_app.default_geo = context.current.audience_app.default_geo || DEFAULT_MANDATORY_GEO;
            const emptyBrandParents = [], emptyBrands = [], emptyProducts = [];
            const defaultGeoParam = context.current.audience_app.default_geo.cc.toLowerCase();
            commercialsParams.push(emptyBrandParents, emptyBrands, emptyProducts, defaultGeoParam);
        }
        $scope.reactSegmentModals.smartTvCommercials.commercialsMetadataPromise = getTvCommercialsMetaDataV2(...commercialsParams);
    }

    function startTvMetadataPromises (newChannel) {
        $scope.reactSegmentModals['tvShows'].tvNetworksMetadataPromise = getTvNetworksMetaData(newChannel.value);
        $scope.reactSegmentModals['tvShows'].tvGenresMetadataPromise = getTvGenresMetaData();
        $scope.reactSegmentModals['tvShows'].tvShowsMetadataPromise = getTvShowsMetaData(newChannel.value);
        if ($scope.hasActivateAudiencePermission(newChannel.value)) $scope.marketsAndAdvertisersPromise = dspService.getAmplificationMarketContext('value');
    }

    function getTvType(channel) {
        const TV_TYPES_BY_CHANNEL = {
            smart_tv_inscape: 'Smart TV',
            tivo: 'TV'
        };
        return TV_TYPES_BY_CHANNEL[channel] || 'online TV';
    }

    function getTvCommercialType(channel) {
        return channel === CHANNELS.smart_tv_inscape?.name ? "Smart TV Inscape" : 'TV';
    }

    function validateChannelFromFilters(nextChannel) {
        if (!nextChannel) return;
        const channelFromFilter = $scope.audienceChannelsFilter.find(channel => channel.value === nextChannel);
        if (!channelFromFilter) return redirectToTVAUpsellPage();
        if (channelFromFilter && nextChannel) {
            context.current.audience_app.current_channel = channelFromFilter;
            $scope.channelFilterSideMenuSelectedChannel = channelFromFilter;
        }
        return $scope.channelAuthorized = true;
    }

    function redirectToTVAUpsellPage() {
        sessionStorage['login_message'] = 'To gain access to TVA audience activation,</br>contact your account manager today.</br></br></br>';
        return $window.location.replace('/login_message');
    }

    $scope.hasActivateAudiencePermission = (channel) => hasActivateAudiencePermission(abiPermissions, channel);

    // PHOB-1710: amplified and always-on segments are created asynchronously by the activation
    // service, which tracks activation.<type>.status (in_progress -> active/failed). We poll that
    // status (reusing audienceMgmt.list) and toast on completion. Polling resumes after a reload for
    // any loaded audience still in progress (see loadFromContext / loadAudienceSubmitHandler / getProgramAudience).
    const ACTIVATION_POLL_INTERVAL_MS = 15000;
    const ACTIVATION_POLL_TIMEOUT_MS = 10 * 60 * 1000;
    const activationPollTimers = {};
    const ACTIVATION_SUCCESS_MSG = {
        amplified: `<p>Your amplified segment was successfully activated and will be available for targeting within 24 hours.</p><p>Visit the segments list table to see your segment.</p>`,
        always_on: `<p>Your always on segment was successfully activated and will be available for targeting within 24 hours.</p><p>Visit the segments list table to see your segment.</p>`,
    };

    async function fetchActivationStatus(audienceId, type) {
        try {
            const audiences = await audienceMgmt.list(current_channel);
            const match = (audiences || []).find((a) => a.id == audienceId);
            return match && match.activation && match.activation[type] && match.activation[type].status;
        } catch (e) {
            return undefined;
        }
    }

    // type: 'amplified' | 'always_on'
    function pollActivationStatus(audienceId, audienceName, type, deadline) {
        const timerKey = `${audienceId}:${type}`;
        if (!audienceId || activationPollTimers[timerKey]) return; // not enough info, or already polling
        const until = deadline || (Date.now() + ACTIVATION_POLL_TIMEOUT_MS);
        const tick = async () => {
            delete activationPollTimers[timerKey];
            const status = await fetchActivationStatus(audienceId, type);
            if (status === 'active') {
                notificator.success({ body: ACTIVATION_SUCCESS_MSG[type] });
                return;
            }
            if (status === 'failed') {
                notificator.error({ body: `Something went wrong... We couldn't amplify the audience "${audienceName}". Please try again later.` });
                return;
            }
            if (Date.now() >= until) return; // give up quietly after the cap; reload re-resumes
            activationPollTimers[timerKey] = $timeout(tick, ACTIVATION_POLL_INTERVAL_MS);
        };
        activationPollTimers[timerKey] = $timeout(tick, ACTIVATION_POLL_INTERVAL_MS);
    }
    $scope.pollActivationStatus = pollActivationStatus;

    $scope.updateAudienceAmplifiedActivated = (activatedMarket, activatedAdvertiser, activatedAmplifiedThreshold) => {
        common.updateAudienceAmplifiedActivated(activatedMarket, activatedAdvertiser, activatedAmplifiedThreshold,
                                                context, $scope, current_channel);
        $scope.audience.activation = context.current.audience_app[current_channel].audience_activation;
        updateAudienceAppForChannel(current_channel, $scope.audience, false);
        // Start polling the async creation; toast the user when it finishes.
        pollActivationStatus($scope.audience.id, $scope.audience.name, 'amplified');
    };

    $scope.updateAudienceAlwaysOnActivated = (activatedDataContractId, activatedDataContractText, activatedCategoryId,
                                                       activatedAlwaysOnThreshold) => {
        $timeout(() => {
            common.updateAudienceAlwaysOnActivated(activatedDataContractId, activatedDataContractText, activatedCategoryId,
                                                   activatedAlwaysOnThreshold, context, $scope, current_channel);
            $scope.audience.activation = context.current.audience_app[current_channel].audience_activation;
            updateAudienceAppForChannel(current_channel, $scope.audience, false);
            pollActivationStatus($scope.audience.id, $scope.audience.name, 'always_on');
        });
    };

    $scope.updateAudienceDeterministicActivated = (activatedMarket, activatedAdvertiser) => {
        common.updateAudienceDeterministicActivated(activatedMarket, activatedAdvertiser, context, $scope, current_channel);
        $scope.audience.activation = context.current.audience_app[current_channel].audience_activation;
        updateAudienceAppForChannel(current_channel, $scope.audience, false);
    };

    $scope.isAudienceActivated = () =>
        $scope.isAudienceDeterministicActivated ||
        $scope.isAudienceAmplifiedActivated ||
        $scope.isAudienceAlwaysOnActivated ||
        !!$scope.audience?.activated_at;

    $scope.updateIsCloneAudienceOpen = (isOpen) => $scope.isCloneAudienceOpen = isOpen;

    $scope.onLogicOperandSummaryClick = () => $scope.updateIsCloneAudienceOpen(true);

    $scope.createClonedAudience = () => {
        $scope.audience = {
            ...$scope.audience,
            name: `${$scope.audience.name}_copy`,
            activation: undefined,
            is_activated: undefined,
            activated_at: undefined,
        };
        delete $scope.audience.id;
        originalAudienceName = '';
        $scope.isAudienceDeterministicActivated = false;
        $scope.isAudienceAmplifiedActivated = false;
        $scope.isAudienceAlwaysOnActivated = false;
        $scope.activatedAmplifiedThreshold = null;
        $scope.activatedAlwaysOnThreshold = null;
        $scope.activatedMarket = null;
        $scope.activatedAdvertiser = null;
        $scope.activatedDataContractId = null;
        $scope.activatedDataContractText = null;
        $scope.activatedCategoryId = null;
        refreshContext(false);
        $scope.cloned_audience_name_auto_generated = true;
        $scope.updateIsCloneAudienceOpen(false);
    };

    $scope.getAmplifiedEstimatedReachGoal = getAmplifiedEstimatedReachGoal;

    $scope.updateHasAudienceData = async (hasData) => {
        $scope.hasAudienceData = hasData;
        await updateAudienceAppForChannel(current_channel, $scope.audience, false);
    };

    $scope.hideChannelDropdown = () => {
        const name = $state.current.name;
        if (!name.startsWith('audience-')) return false;
        if (name !== 'audience-builder') return true;

        return !abiPermissions.hasPermission(PERMISSION.AUDIENCE_AU_TELCO_CHANNEL) &&
            !abiPermissions.hasPermission(PERMISSION.AUDIENCE_LINKEDIN_CHANNEL) &&
            !abiPermissions.hasPermission(PERMISSION.AUDIENCE_SG_TELCO_CHANNEL);
    };

    $scope.isSegmentWithDate = (index) => {
        const segment = $scope.audience.segment[index];
        return segment && segment.hasOwnProperty('startDate') && segment.hasOwnProperty('endDate');
    };

    $scope.isDeterministicDynamicAllowed = () => isDeterministicDynamicActivationAllowed($scope.audience.segment);
    $scope.allowDeterministicSegment = abiPermissions.hasPermission(deterministicPermissionName);
    $scope.allowCustomPriceSegment = abiPermissions.hasPermission(customPricePermissionName);
    $scope.allowOptimizeSegment = abiPermissions.hasPermission(optimizeSegmentPermissionName);

    setShowAudienceIpCount(current_channel);
    
    function updateFirstPartySegments(segments, firstPartyData) {
        if (!firstPartyData) return;
        // First, update segments with fresh data and mark which ones were found
        const segmentsToRemove = [];
        
        segments.forEach((segment, index) => {
            if (segment.type !== '1st party') return;
            
            // Try to match by different possible fields
            let firstPartySegment = firstPartyData.find((item) => item.id === segment.id);
            if (!firstPartySegment && segment.segment_value) {
                firstPartySegment = firstPartyData.find((item) => item.segment_value === segment.segment_value);
            }
            if (!firstPartySegment && segment.value) {
                firstPartySegment = firstPartyData.find((item) => item.segment_value === segment.value);
            }
            
            if (firstPartySegment) {
                // Update with fresh data
                segments[index] = {
                    ...segments[index],
                    label: firstPartySegment.label,
                    segment_size: firstPartySegment.segment_size,
                    expires_at: firstPartySegment.expires_at,
                    pending_expiration: firstPartySegment.pending_expiration
                };
                
                // Mark for removal if it has pending_expiration: true
                if (firstPartySegment.pending_expiration === true) {
                    segmentsToRemove.push(index);
                }
            } else {
                // Segment not found in API response - it was deleted from DB
                segmentsToRemove.push(index);
            }
        });
        
        if (!segmentsToRemove.length) return;

        $scope.resetAudience(true);
    }
    
    function getSegmentWithAppliedMandatoryFields(segment) {
        updateFirstPartySegments(segment, $scope.segments);
        
        if (!CHANNELS[current_channel]?.isGeoMandatory) return _.reject(segment, {type: "country"});
        let resultSegment = _.cloneDeep(segment);
        context.current.audience_app.default_geo = context.current.audience_app.default_geo || DEFAULT_MANDATORY_GEO;
        let countryRow = _.find(resultSegment, {type: "country"});
        if (!countryRow) {
            resultSegment.push({type: "country", geo: [context.current.audience_app.default_geo]});
        }
        _.each(resultSegment, row => {
            if (row.type === 'demographics') {
                delete row.geo;
            }
        });
        _.remove(resultSegment, (row) => row.type === 'demographics' &&
                                         _.isEmpty(_.omit(row, ['index', 'operand', 'type', 'noDelete'])));
        return resultSegment;
    }

    $scope.isSegmentRowWithoutDelete = ({type}) => type === 'country';

    $scope.isSegmentExpired = (segment) => {
        if (!segment.expires_at) return false;
        return segment.pending_expiration;
    };

    $scope.getSegmentExpirationText = (segment) => {
        if (!segment.expires_at) return '';
        const expirationDate = new Date(segment.expires_at);
        const now = new Date();
        const isExpired = segment.pending_expiration;
        const formattedDate = expirationDate.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
        
        return isExpired ? `Expired on ${formattedDate}` : `Expires on ${formattedDate}`;
    };
}

audienceBuilderModule.filter("trusted_html", ['$sce', function ($sce) {
    return function (htmlCode) {
        return $sce.trustAsHtml(htmlCode);
    }
}]);

export default audienceBuilderModule;
